// extracted by mini-css-extract-plugin
module.exports = {"heading":"NotFound_heading__HLOXR","text":"NotFound_text__1unC6","redirectButton":"NotFound_redirectButton__bXvj6"};